import HistoryDashboard from '../features/history/HistoryDashboard.jsx';

export default function History() {
  return (
    <div className="mx-auto max-w-6xl">
      <HistoryDashboard />
    </div>
  );
}
